define('companiesListFiltersEditView',[
  'module',
  'underscore',
  'filtersBannerEditView',
  'template!companiesListFiltersEditView'
], function (
  Module,
  _,
  FiltersBannerEditView,
  Tpl
) {
  'use strict';

  Module.exports = FiltersBannerEditView.extend({
    template: Tpl,
    windowTitle: _.i18n('common.filters'),

    ui: _.extend({
      name: '.body .name input',
      emailDomain: '.body .email-domain input',
      countryCode: '.body .country-code input'
    }, FiltersBannerEditView.prototype.ui),

    onRender: function () {
      this.ui.name.val(this.model.get('name') || '');
      this.ui.emailDomain.val(this.model.get('emailDomain') || '');
      this.ui.countryCode.val(this.model.get('countryCode') || '');
      FiltersBannerEditView.prototype.onRender.apply(this, arguments);
    },

    onConfirm: function () {
      this.model.set({
        name: this.ui.name.val().trim(),
        emailDomain: this.ui.emailDomain.val().trim(),
        countryCode: this.ui.countryCode.val().trim()
      });
      FiltersBannerEditView.prototype.onConfirm.apply(this, arguments);
    },

    onReset: function () {
      this.ui.name.val('');
      this.ui.emailDomain.val('');
      this.ui.countryCode.val('');
    }
  });
});

